import {Injectable, inject} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import { Global } from './core/Global';


@Injectable()

export class RequestService {
	private url: string = Global.url_seguros
	private _http = inject(HttpClient)


	incorporation(params: any): Observable<any> {
		return this._http.post(this.url + 'requests/incorporation', params)
	}

	modify(params: any, contract: any): Observable<any> {
		params.current = contract
		return this._http.patch(this.url + 'requests', params)
	}

	exclution(params: any): Observable<any> {
		return this._http.post(this.url + 'requests/exclution', params)
	}
	
	update(params: any): Observable<any> {
		return this._http.put(this.url + 'requests', params)
	}

	approvalWorkflow(data: any, approve: any): Observable<any> {
		return this._http.post(this.url + 'request/approval-workflow', { data, approve })
	}

	cancel(request: any): Observable<any> {
		return this._http.post(this.url + 'request/cancel', request)
	}

	forceDelete(id: string): Observable<any> {
		return this._http.delete(this.url + 'request/' + id)
	}
	
	getTypeMovements(): Observable<any> {
		return this._http.get(this.url + 'requests/type-movements')
	}

	getRequests(params: any): Observable<any> {
		return this._http.post(this.url + 'requests', params)
	}

	getRequest(id: any): Observable<any> {
		return this._http.get(this.url + 'requests/' + id)
	}

	generateExcel(endpoint: string, params: any): Observable<Blob> {
		return this._http.post(this.url + endpoint, params, { responseType: 'blob' })
	}

	getPermissions(): Observable<any> {
		return this._http.get(this.url + 'permissions/all')
	}

	createPermission(params: any): Observable<any> {
		return this._http.post(this.url + 'permissions', params)
	}

	updatePermission(id: any, params: any): Observable<any> {
		return this._http.patch(this.url + 'permissions/' + id, params)
	}

	getFrontendPermissions(roleId: any): Observable<any> {
		return this._http.get(this.url + 'permissions/frontend/' + roleId)
	}

	createFrontendPermission(params: any): Observable<any> {
		return this._http.post(this.url + 'permissions/frontend', params)
	}

	updateFrontendPermission(id: any, params: any): Observable<any> {
		return this._http.patch(this.url + 'permissions/frontend/' + id, params)
	}

	deleteFrontendPermission(id: any): Observable<any> {
		return this._http.delete(this.url + 'permissions/frontend/' + id)
	}

	getAllMenus(): Observable<any> {
		return this._http.get(this.url + 'permissions/menus')
	}

	getMatrix(): Observable<any> {
		return this._http.get(this.url + 'permissions/matrix')
	}

	toggleMatrix(roleId: string, permissionId: string, enabled: boolean): Observable<any> {
		return this._http.post(this.url + 'permissions/matrix/toggle', { roleId, permissionId, enabled })
	}

	getStateRules(permissionId: string): Observable<any> {
		return this._http.get(this.url + 'permissions/state-rules/' + permissionId)
	}

	saveStateRule(params: any): Observable<any> {
		return this._http.post(this.url + 'permissions/state-rules', params)
	}

	deleteStateRule(id: string): Observable<any> {
		return this._http.delete(this.url + 'permissions/state-rules/' + id)
	}

}
